export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 animate-fade-up">
      <div>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight leading-none text-[#0A0A0A]">
          {title}
        </h1>
        {subtitle && <p className="mt-3 text-[#575755] text-base max-w-2xl">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function StatCard({ label, value, sub, index = 0 }) {
  return (
    <div
      className="bg-white border border-[#E5E5E2] rounded-sm p-6 animate-fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="text-xs tracking-[0.2em] uppercase font-semibold text-[#575755]">{label}</div>
      <div className="mt-3 font-serif text-3xl sm:text-4xl text-[#1F3C88] leading-none">{value}</div>
      {sub && <div className="mt-2 text-sm text-[#575755]">{sub}</div>}
    </div>
  );
}

const STATUS_STYLES = {
  green: "bg-[#E7F0EA] text-[#2E5C47]",
  orange: "bg-[#FBEAE1] text-[#F7941D]",
  amber: "bg-[#FBF2DE] text-[#B07D14]",
  red: "bg-[#F6E4E4] text-[#992B2B]",
  gray: "bg-[#F0EFEC] text-[#575755]",
  emerald: "bg-[#1F3C88] text-white",
};

export function StatusBadge({ children, tone = "gray" }) {
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${STATUS_STYLES[tone]}`}>
      {children}
    </span>
  );
}

export const currency = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);

export function KpiTile({ color, Icon, value, label, rows = [], index = 0, testid }) {
  return (
    <div data-testid={testid} className="relative bg-white rounded-2xl shadow-[0_1px_3px_rgba(16,24,40,0.06),0_8px_24px_-12px_rgba(16,24,40,0.12)] overflow-hidden animate-fade-up" style={{ animationDelay: `${index * 60}ms` }}>
      <div className="absolute top-0 inset-x-0 h-1.5" style={{ backgroundColor: color }} />
      <div className="p-6 pt-8">
        <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6 shadow-sm" style={{ backgroundColor: color }}>
          {Icon && <Icon className="w-7 h-7 text-white" strokeWidth={2.4} />}
        </div>
        <div className="text-5xl font-extrabold tracking-tight text-[#1A2233] leading-none">{value}</div>
        <div className="mt-4 text-lg font-bold text-[#3A3A38]">{label}</div>
        <div className="mt-3 space-y-1.5">
          {rows.map(([k, v]) => (
            <div key={k} className="flex items-center justify-between text-sm">
              <span className="text-[#9a978f]">{k}</span>
              <span className="font-semibold text-[#3A3A38] tabular-nums">{v}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
